module.exports = __webpack_public_path__ + "45035068.svg";